import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["children", "inverse", "required", "size", "tooltip"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { IconInfoBadgedSmallFilled } from '@teamleader/ui-icons';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Box from '../box';
import Tooltip from '../tooltip';
import Icon from '../icon';
import { TextBodyCompact, TextDisplay, TextSmall } from '../typography';
var TooltippedIcon = Tooltip(Icon);
/** @type {React.ComponentType<any>} */

var Label = /*#__PURE__*/function (_PureComponent) {
  _inherits(Label, _PureComponent);

  var _super = _createSuper(Label);

  function Label() {
    _classCallCheck(this, Label);

    return _super.apply(this, arguments);
  }

  _createClass(Label, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          inverse = _this$props.inverse,
          required = _this$props.required,
          size = _this$props.size,
          tooltip = _this$props.tooltip,
          others = _objectWithoutProperties(_this$props, _excluded);

      var childProps = {
        inverse: inverse,
        marginTop: 1,
        size: size
      };
      var Element = size === 'large' ? TextDisplay : TextBodyCompact;
      return /*#__PURE__*/React.createElement(Box, _extends({
        display: "block",
        element: "label",
        marginBottom: 3
      }, others), React.Children.map(children, function (child) {
        if (typeof child !== 'string') {
          return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, childProps), child.props));
        }

        return /*#__PURE__*/React.createElement(Box, {
          display: "flex",
          alignItems: "center"
        }, /*#__PURE__*/React.createElement(Element, {
          color: inverse ? 'neutral' : 'teal',
          tint: inverse ? 'lightest' : 'darkest',
          element: "span"
        }, child), required && /*#__PURE__*/React.createElement(TextSmall, {
          color: "ruby",
          element: "span",
          marginLeft: 1,
          tint: "dark"
        }, "*"), tooltip && /*#__PURE__*/React.createElement(TooltippedIcon, {
          tooltip: /*#__PURE__*/React.createElement(TextSmall, null, tooltip),
          tooltipSize: "small",
          color: inverse ? 'neutral' : 'teal',
          tint: inverse ? 'lightest' : 'darkest',
          marginLeft: 1
        }, /*#__PURE__*/React.createElement(IconInfoBadgedSmallFilled, null)));
      }));
    }
  }]);

  return Label;
}(PureComponent);

export { Label as default };
Label.defaultProps = {
  inverse: false,
  required: false,
  size: 'medium'
};